module.exports = __webpack_public_path__ + "media/images/dummy-car-item-79eae2258ed0fb3a1a49593137cedd51.jpg";